
/* custom add to cart product page wth keep shopping button */
document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector(".cutom-add-to-cart");
  const realAddToCartBtn = document.querySelector(".add-to-cart");

  if (!addToCartBtn || !realAddToCartBtn) return;

  // Create/ensure Keep Shopping button inside cart drawer
  function ensureKeepShoppingInDrawer() {
    const DRAWER_SELECTORS = [
      "#CartDrawer",            // Dawn common
      "cart-drawer",            // component
      ".drawer.active",         // fallback
      ".cart-drawer"            // fallback
    ];

    let drawer = null;
    for (const s of DRAWER_SELECTORS) {
      const el = document.querySelector(s);
      if (el) { drawer = el; break; }
    }

    // If drawer not found yet, still show inline button if exists
    const inlineContainer = document.querySelector(".cus-btn_add");
    const inlineBtn = document.querySelector(".cus-btn_add a");
    if (inlineBtn) {
      inlineBtn.textContent = "KEEP SHOPPING";
      inlineBtn.href = "/collections/shop";
    }
    if (inlineContainer) inlineContainer.style.display = "block";

    if (!drawer) return;

    // Try to place near drawer footer / checkout area
    const target =
      drawer.querySelector(".drawer__footer") ||
      drawer.querySelector(".cart-drawer__footer") ||
      drawer.querySelector(".drawer__inner") ||
      drawer;

    let wrap = drawer.querySelector(".cus-btn_add");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "cus-btn_add";
      wrap.style.display = "block";
      wrap.style.marginTop = "12px";
      target.appendChild(wrap);
    }

    let btn = wrap.querySelector("a.keep-shopping-btn");
    if (!btn) {
      btn = document.createElement("a");
      btn.className = "keep-shopping-btn";
      wrap.appendChild(btn);
    }

    btn.textContent = "KEEP SHOPPING";
    btn.href = "/collections/shop";

    // Make sure visible
    wrap.style.display = "block";
  }

  // After add-to-cart, drawer content loads async → poll for a moment
  function showKeepShoppingAfterCartUpdate() {
    let tries = 0;
    const timer = setInterval(() => {
      ensureKeepShoppingInDrawer();
      tries++;
      if (tries >= 20) clearInterval(timer); // ~5 seconds (20 * 250ms)
    }, 250);
  }


  // Custom Add-to-cart click
  addToCartBtn.addEventListener("click", function () {
    let allSelected = true;

    document.querySelectorAll(".custom-dropdown").forEach((dropdown) => {
      const selected = dropdown.querySelector(".dropdown-selected");
      let errorMsg = dropdown.parentElement.querySelector(".error-text");

      if (!errorMsg) {
        errorMsg = document.createElement("div");
        errorMsg.classList.add("error-text");
        errorMsg.textContent = "Select print";
        dropdown.parentElement.appendChild(errorMsg);
      }

      const text = selected ? selected.textContent.trim() : "";
      if (!text || text.startsWith("Choose")) {
        allSelected = false;
        dropdown.classList.add("dropdown-error");
        errorMsg.style.display = "block";
      } else {
        dropdown.classList.remove("dropdown-error");
        errorMsg.style.display = "none";
      }
    });

    if (!allSelected) {
      const conError = document.querySelector(".error_con_msg");
      if (conError) conError.style.display = "block";
      return;
    }

    realAddToCartBtn.click();
    showKeepShoppingAfterCartUpdate();
  });

  //Click handler (works for injected + inline)
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("a.keep-shopping-btn, .cus-btn_add a");
    if (!btn) return;

    e.preventDefault();

    // Reset removed here too
    // resetDropdowns();

    window.location.href = "/collections/shop";
  });

  // Clear dropdown error on selection
  document.querySelectorAll(".custom-dropdown .dropdown-item").forEach((item) => {
    item.addEventListener("click", function () {
      const dropdown = this.closest(".custom-dropdown");
      const errorMsg = dropdown.parentElement.querySelector(".error-text");
      dropdown.classList.remove("dropdown-error");
      if (errorMsg) errorMsg.style.display = "none";
    });
  });
});


/*  edit product dropwn variant */
// document.addEventListener("DOMContentLoaded", function () {

//   //  On radio change — add v=s when SLIMLINE is selected
//   document.querySelectorAll('.variant-input input[type="radio"]').forEach(function(radio){
//     radio.addEventListener('change', function(){
//       if (this.value === "SLIMLINE") {
//         const params = new URLSearchParams(window.location.search);
//         params.set('v', 's');
//         history.pushState(null, '', window.location.pathname + '?' + params.toString());
//       }
//     });
//   });

//   // On page load — if v=s exists, auto-select SLIMLINE
//   const paramsOnLoad = new URLSearchParams(window.location.search);
//   if (paramsOnLoad.get('v') === 's') {

//     const checkSlimline = setInterval(function() {
//       const slimInput = document.querySelector('.variant-wrapper .variant-input-wrap .variant-input[data-value="SLIMLINE"] input');
//       if (slimInput) {
//         slimInput.click();
//         clearInterval(checkSlimline);
//       }
//     }, 200); // check every 200ms

//     // 3️⃣ Remove v=s from URL after 5 seconds
//     setTimeout(function() {
//       const params = new URLSearchParams(window.location.search);
//       params.delete('v');
//       const newUrl = params.toString()
//         ? window.location.pathname + '?' + params.toString()
//         : window.location.pathname;
//       history.replaceState(null, '', newUrl);
//     }, 1000); // 5 seconds
//   }

// });

/* edit products dropdown */
document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector("form[action='/cart/add']");
  if (!productForm) return;

  const productHandle = document.querySelector("main")?.dataset.productHandle || "";
  const isMuseEdit = productHandle.includes("the-muse-edit");

  const skipOldDropdownScript =
    productHandle.includes("after-dark") ||
    productHandle.includes("supper-club") ||
    productHandle.includes("soiree");

  if (skipOldDropdownScript) return;

  // ---- Fit swatches label and hiding for Muse Edit ----
  if (isMuseEdit) {
    // Change heading
    const fitLabel = document.querySelector("#can-couture-section .fit-swatches .product-form__label h3");
    if (fitLabel) fitLabel.textContent = "Muse Edit ONLY:";

    // Hide swatches buttons
    const fitSwatches = document.querySelector("#can-couture-section .fit-options");
    if (fitSwatches) fitSwatches.style.display = "none";
  } else {
    // Normal products: set hidden input for Can Couture Fit
    function setFitHidden(value) {
      let input = productForm.querySelector("input[name='properties[Can Couture™ Fit]']");
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[Can Couture™ Fit]";
        productForm.appendChild(input);
      }
      input.value = value;
    }

    const initialActive = document.querySelector(".fit-options .fit-swatch.active");
    if (initialActive) setFitHidden(initialActive.dataset.value);

    document.querySelectorAll(".fit-options .fit-swatch").forEach(btn => {
      btn.addEventListener("click", function() {
        this.parentNode.querySelectorAll(".fit-swatch").forEach(s => s.classList.remove("active"));
        this.classList.add("active");
        setFitHidden(this.dataset.value);
        const fitBlock = this.closest(".product-meta-dropdown-block");
        const err = fitBlock?.querySelector(".meta-error-msg");
        if (err) err.style.display = "none";
      });
    });
  }

  // ---- Dropdown setup ----
  function setupDropdown(dd) {
    const selected = dd.querySelector(".meta-dropdown-selected");
    const list = dd.querySelector(".meta-dropdown-list");
    const wrapper = dd.closest(".product-meta-dropdown-block");
    const errorMsg = wrapper?.querySelector(".meta-error-msg");
    if (!selected || !list) return;

    selected.style.cursor = "pointer";
    selected.addEventListener("click", function(e) {
      e.stopPropagation();
      document.querySelectorAll(".custom-meta-dropdown.active").forEach(x => {
        if (x !== dd) x.classList.remove("active");
      });
      dd.classList.toggle("active");
    });

    list.addEventListener("click", function(e) {
      const item = e.target.closest(".meta-dropdown-item");
      if (!item) return;
      e.stopPropagation();
      const rawValue = (item.dataset.value || item.textContent || "").trim();
      if (!rawValue) return;
      const img = item.dataset.image || "";
      selected.innerHTML = (img ? `<img src="${img}" width="36" height="36" style="margin-right:8px;">` : "") + rawValue;
      dd.dataset.selectedValue = rawValue;
      dd.classList.remove("active");
      if (errorMsg) errorMsg.style.display = "none";
      dd.classList.remove("meta-required-error");
    });
  }

  document.querySelectorAll(".custom-meta-dropdown").forEach(dd => setupDropdown(dd));

  document.addEventListener("click", function() {
    document.querySelectorAll(".custom-meta-dropdown.active").forEach(dd => dd.classList.remove("active"));
  });

  // ---- Add-to-cart validation & set properties ----
  const addToCartBtn = productForm.querySelector("button[type='submit'],button[name='add']");
  if (!addToCartBtn) return;

  addToCartBtn.addEventListener("click", function(e) {
    let invalid = false;

    document.querySelectorAll(".custom-meta-dropdown").forEach((dd) => {
      const sel = dd.dataset.selectedValue;
      const wrapper = dd.closest(".product-meta-dropdown-block");
      const err = wrapper?.querySelector(".meta-error-msg");
      const sectionId = dd.closest(".edit-product-section")?.id || "";
      let propertyName = "";

      // --- Determine property name based on section and Muse Edit ---
      if (sectionId === "can-couture-section") {
        const sleeveNum = wrapper?.querySelector("label h5")?.textContent?.trim() || "Sleeve 1";
        if (isMuseEdit) {
          propertyName = `Sleeve ${sleeveNum.split(' ')[1]} Faux Fur`;
        } else {
          propertyName = `Can Couture® ${sleeveNum} Pattern`;
        }
      } else if (sectionId === "style-tiles-section") {
        let setLabel = wrapper?.querySelector("label h5")?.textContent?.trim() || "Set 1";
        const match = setLabel.match(/\d+/);
        const setNum = match ? match[0] : "1";
        propertyName = `Style Tiles™ Set ${setNum} Pattern`;
      } else if (sectionId === "bottle-couture-section") {
        propertyName = `Bottle Couture® Pattern`;
      }

      // --- Validation ---
      if (!sel || sel.trim() === "") {
        invalid = true;
        if (err) err.style.display = "block";
        dd.classList.add("meta-required-error");
      } else {
        if (err) err.style.display = "none";
        dd.classList.remove("meta-required-error");

        // --- Create hidden input for cart property ---
        let hidden = productForm.querySelector(`input[name='properties[${propertyName}]']`);
        if (!hidden) {
          hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = `properties[${propertyName}]`;
          productForm.appendChild(hidden);
        }
        hidden.value = sel;
      }
    });

    if (invalid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, { capture: true });

 
});

/* new arrival shop page */
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-new-arrivals]');
  if (!root) return;

  const scroller = root.querySelector('.cstm-new-arrivals-scroll');
  const prevBtn = root.querySelector('.cstm-nav--prev');
  const nextBtn = root.querySelector('.cstm-nav--next');

  if (!scroller || !prevBtn || !nextBtn) return;

  function getStep() {
    const firstCard = scroller.querySelector('.cstm-new-arrivals-card');
    if (!firstCard) return scroller.clientWidth;
    const styles = window.getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);
    return firstCard.offsetWidth + gap;
  }

  function updateButtons() {
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    const atStart = scroller.scrollLeft <= 2;
    const atEnd = scroller.scrollLeft >= (maxScrollLeft - 2);

    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
  }

  prevBtn.addEventListener('click', () => {
    scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
  });

  scroller.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);

  updateButtons();
});


/* load more collections */
(function () {
  // ----------------------------
  // Helpers
  // ----------------------------
  function fireSwymEvent() {
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  function getCurrentGrid(btn) {
    var scope =
      (btn && btn.closest && btn.closest("[data-scroll-to]")) ||
      document.getElementById("CollectionAjaxContent") ||
      document.getElementById("ProductGridContainer") ||
      document;
    return scope.querySelector(".grid--uniform") || scope.querySelector(".grid");
  }

  function getNewGrid(doc) {
    var ajax =
      doc.getElementById("CollectionAjaxContent") ||
      doc.getElementById("ProductGridContainer") ||
      doc;
    return ajax.querySelector(".grid--uniform") || ajax.querySelector(".grid");
  }

  function hydrateImages(scope) {
    if (!scope) return;

    scope.querySelectorAll("img[data-src]").forEach(function (img) {
      var src = img.getAttribute("data-src");
      if (src) img.src = src;
      img.removeAttribute("data-src");
    });

    scope.querySelectorAll("img[data-srcset]").forEach(function (img) {
      var ss = img.getAttribute("data-srcset");
      if (ss) img.srcset = ss;
      img.removeAttribute("data-srcset");
    });

    scope.querySelectorAll("img[data-original]").forEach(function (img) {
      var src = img.getAttribute("data-original");
      if (src && !img.src) img.src = src;
    });

    scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = "eager";
    });

    scope.querySelectorAll("[data-bg]").forEach(function (el) {
      var bg = el.getAttribute("data-bg");
      if (bg) el.style.backgroundImage = "url(" + bg + ")";
    });

    window.dispatchEvent(new Event("scroll"));
    window.dispatchEvent(new Event("resize"));
    document.dispatchEvent(new Event("lazyloaded"));
  }

  // ----------------------------
  // ✅ Observer (Filters/Sort/AJAX render)
  // ----------------------------
  function observeGridForFilters() {
    var targets = [
      document.getElementById("CollectionAjaxContent"),
      document.getElementById("ProductGridContainer"),
      document.querySelector(".collection-grid__wrapper"),
    ].filter(Boolean);

    if (!targets.length) return;

    targets.forEach(function (target) {
      if (target.__swymObserved) return;
      target.__swymObserved = true;

      var obs = new MutationObserver(function (mutations) {
        var changed = false;
        for (var i = 0; i < mutations.length; i++) {
          if ((mutations[i].addedNodes && mutations[i].addedNodes.length) || mutations[i].type === "childList") {
            changed = true;
            break;
          }
        }
        if (!changed) return;

        // debounce (filters multiple renders)
        clearTimeout(target.__swymTimer);
        target.__swymTimer = setTimeout(function () {
          // ✅ reset load-more state (filters replace DOM)
          isLoading = false;
          fireSwymEvent();
        }, 150);
      });

      obs.observe(target, { childList: true, subtree: true });
    });
  }

  // ----------------------------
  // Load More
  // ----------------------------
  var isLoading = false;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("#load-more-products");
    if (!btn) return;

    if (isLoading) return;

    var nextUrl = btn.getAttribute("data-next-url");
    if (!nextUrl) {
      btn.style.display = "none";
      return;
    }

    var currentGrid = getCurrentGrid(btn);
    if (!currentGrid) return;

    isLoading = true;
    btn.classList.add("loading");

    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    btn.blur();

    fetch(nextUrl, { credentials: "same-origin" })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        var newGrid = getNewGrid(doc);
        if (!newGrid) return;

        var newItems = newGrid.querySelectorAll(".grid__item.grid-product, .grid__item");

        newItems.forEach(function (item) {
          if (item.closest && item.closest(".grid__item--sidebar")) return;
          currentGrid.appendChild(item);
        });

        hydrateImages(currentGrid);

        // ✅ Swym official event for dynamic load
        fireSwymEvent();

        requestAnimationFrame(function () {
          window.scrollTo(0, scrollY);
        });

        // Update next page url from loaded HTML
        var nextBtn = doc.querySelector("#load-more-products");
        var newNext = nextBtn ? nextBtn.getAttribute("data-next-url") : "";
        btn.setAttribute("data-next-url", newNext || "");

        if (!newNext) btn.style.display = "none";
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove("loading");
        isLoading = false;
      });
  });

  // ----------------------------
  // Init
  // ----------------------------
  document.addEventListener("DOMContentLoaded", function () {
    var btn = document.getElementById("load-more-products");
    if (btn) hydrateImages(getCurrentGrid(btn));

    observeGridForFilters();

    // ✅ init once for first render
    fireSwymEvent();
  });

  // If sections reload (some themes)
  document.addEventListener("shopify:section:load", function () {
    observeGridForFilters();
    isLoading = false;
    fireSwymEvent();
  });
})();




/*product accordian issue */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-tabs').forEach((wrap) => {
    const details = wrap.querySelectorAll('details');
    // Avoid duplicate listeners
    if (wrap.dataset.tabsInit === '1') return;
    wrap.dataset.tabsInit = '1';
    // Close others when one opens
    wrap.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement)) return;
      if (!d.open) return;
      details.forEach((other) => {
        if (other !== d) other.open = false;
      });
    }, true);
    // iOS/Safari: prevent rapid double tap issues on summary
    wrap.querySelectorAll('summary').forEach((sum) => {
      sum.addEventListener('click', (ev) => {
        // Let native toggle happen, but block accidental double-fire
        if (sum.dataset.locked === '1') {
          ev.preventDefault();
          return;
        }
        sum.dataset.locked = '1';
        setTimeout(() => { sum.dataset.locked = '0'; }, 250);
      }, { passive: false });
    });
  });
});

/* Close all submenu mobile */
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('NavDrawer');
  if (!drawer) return;

  let allowSet = new Set();
  let allowUntil = 0;

  function getControllerForPanel(panel) {
    if (!panel || !panel.id) return null;
    return drawer.querySelector(`button.collapsible-trigger[aria-controls="${panel.id}"]`);
  }

  // ✅ Keep clicked button + all its parent controllers open
  function buildAllowSet(btn) {
    const set = new Set();
    if (!btn) return set;

    set.add(btn);

    // walk up: button -> (panel it controls) -> parent panel -> its controller -> ...
    let currentBtn = btn;

    while (currentBtn) {
      // find nearest parent collapsible-content that contains this button
      const parentPanel = currentBtn.closest('.collapsible-content');
      const parentController = getControllerForPanel(parentPanel);
      if (!parentController) break;

      set.add(parentController);
      currentBtn = parentController;
    }

    return set;
  }

  function setAllow(btn) {
    allowSet = buildAllowSet(btn);
    allowUntil = Date.now() + 1200; // little longer to survive theme toggles
  }

  function closeAllExceptAllowed() {
    const now = Date.now();

    // if allow window expired, allow nothing
    const allowed = now < allowUntil ? allowSet : new Set();

    // Close triggers
    drawer.querySelectorAll('button.collapsible-trigger.is-open').forEach(btn => {
      if (allowed.has(btn)) return;
      btn.classList.remove('is-open');
      btn.setAttribute('aria-open', 'false');
      btn.setAttribute('aria-expanded', 'false');
    });

    // Close panels
    drawer.querySelectorAll('.collapsible-content.is-open').forEach(panel => {
      const controller = getControllerForPanel(panel);
      if (controller && allowed.has(controller)) return;

      panel.classList.remove('is-open');
      panel.style.removeProperty('height'); // let theme handle again
    });
  }

  // ✅ capture early on mobile
  drawer.addEventListener('pointerdown', (e) => {
    const btn = e.target.closest('button.collapsible-trigger');
    if (btn) setAllow(btn);
  }, true);

  drawer.addEventListener('touchstart', (e) => {
    const btn = e.target.closest('button.collapsible-trigger');
    if (btn) setAllow(btn);
  }, { capture: true, passive: true });

  // ✅ When hamburger opens: collapse auto-opened items (active links)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-drawer-open-nav, .header__icon--menu, button[aria-controls="NavDrawer"]')) {
      allowSet = new Set();
      allowUntil = 0;
      setTimeout(closeAllExceptAllowed, 0);
      setTimeout(closeAllExceptAllowed, 120);
      setTimeout(closeAllExceptAllowed, 260);
      setTimeout(closeAllExceptAllowed, 420);
    }
  });

  // ✅ When clicking a normal link, keep menu collapsed
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('a.mobile-nav__link')) {
      allowSet = new Set();
      allowUntil = 0;
      setTimeout(closeAllExceptAllowed, 0);
    }
  });

  // ✅ Observe only class changes; keep user-open + its parents intact
  const obs = new MutationObserver(() => {
    closeAllExceptAllowed();
  });

  obs.observe(drawer, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // initial cleanup
  closeAllExceptAllowed();
});


/* alternating collections pattern dropdwn */
document.addEventListener("DOMContentLoaded", function () {
  const ROOT_SELECTOR = ".custom-pattern-products";
  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  function closeAll(exceptWrap) {
    root.querySelectorAll(".pattern-shop").forEach((wrap) => {
      if (exceptWrap && wrap === exceptWrap) return;

      const btn = wrap.querySelector(".shop-by-pattern-btn");
      const list = wrap.querySelector(".pattern-collections-list");

      if (list) list.classList.remove("open");
      if (btn) btn.classList.remove("active");
    });
  }

  // Toggle on button click (event delegation)
  root.addEventListener("click", function (e) {
    const btn = e.target.closest(".shop-by-pattern-btn");
    if (!btn) return;

    const wrap = btn.closest(".pattern-shop");
    if (!wrap) return;
    const list = wrap.querySelector(".pattern-collections-list");
    // If this item doesn't have dropdown list (it's SHOP link case), do nothing
    if (!list) return;

    e.preventDefault();

    const isOpen = list.classList.contains("open");

    // Close other dropdowns
    closeAll(wrap);

    // Toggle current
    if (!isOpen) {
      list.classList.add("open");
      btn.classList.add("active");
    } else {
      list.classList.remove("open");
      btn.classList.remove("active");
    }
  });

  // Close on outside click
  document.addEventListener("click", function (e) {
    // If click is inside the component, ignore (handled above)
    if (e.target.closest(ROOT_SELECTOR)) return;

    closeAll();
  });

  // Optional: close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll();
  });
});


/* product tabs */
document.addEventListener("DOMContentLoaded", function () {
(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  let savedY = 0;          // global scroll position
  let activeDetails = null; // which details we are opening

  function closeAllExcept(current) {
    document.querySelectorAll("details.product-tab_tsu[open]").forEach((d) => {
      if (d !== current) d.removeAttribute("open");
    });
  }

  function restoreScroll() {
    // restore twice (some themes scroll again after first restore)
    requestAnimationFrame(() => {
      window.scrollTo(0, savedY);
      requestAnimationFrame(() => {
        window.scrollTo(0, savedY);
      });
    });
  }

  function bindOne(detailsEl) {
    if (!detailsEl || detailsEl.__oneOpenBound) return;

    const summary = detailsEl.querySelector("summary.product-tab__summary");
    if (!summary) return;

    // skip locked
    if (summary.getAttribute("data-locked") === "1") {
      detailsEl.__oneOpenBound = true;
      return;
    }

    //  Save scroll BEFORE native toggle (pointerdown works best)
    summary.addEventListener(
      "pointerdown",
      function () {
        savedY = window.scrollY || window.pageYOffset || 0;
        activeDetails = detailsEl;
      },
      { capture: true }
    );

    //  When opened, close others + restore scroll
    detailsEl.addEventListener("toggle", function () {
      // Only act for the tab that was just interacted with
      if (detailsEl !== activeDetails) return;

      if (detailsEl.open) {
        closeAllExcept(detailsEl);
        // avoid focus causing scroll
        summary.blur();
        restoreScroll();
      } else {
        // if user closed the same tab, just restore once (optional)
        summary.blur();
        restoreScroll();
      }

      // reset
      activeDetails = null;
    });

    detailsEl.__oneOpenBound = true;
  }

  function initAll() {
    document.querySelectorAll("details.product-tab_tsu").forEach(bindOne);
  }

  onReady(function () {
    initAll();

    // Optional: keep only first open on load
    const opened = document.querySelectorAll("details.product-tab_tsu[open]");
    opened.forEach((d, i) => {
      if (i > 0) d.removeAttribute("open");
    });

    // Shopify re-render safe
    const obs = new MutationObserver(initAll);
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();

});

/* products can couture fit variant update url */
//  document.addEventListener("DOMContentLoaded", function () {

//   // 1️⃣ On radio change — add v=s when SLIMLINE is selected
//   document.querySelectorAll('.variant-input input[type="radio"]').forEach(function(radio){
//     radio.addEventListener('change', function(){
//       if (this.value === "SLIMLINE") {
//         const params = new URLSearchParams(window.location.search);
//         params.set('v', 's');
//         history.pushState(null, '', window.location.pathname + '?' + params.toString());
//       }
//     });
//   });

//   // 2️⃣ On page load — if v=s exists, auto-select SLIMLINE
//   const paramsOnLoad = new URLSearchParams(window.location.search);
//   if (paramsOnLoad.get('v') === 's') {

//     const checkSlimline = setInterval(function() {
//       const slimInput = document.querySelector('.variant-wrapper .variant-input-wrap .variant-input[data-value="SLIMLINE"] input');
//       if (slimInput) {
//         slimInput.click();
//         clearInterval(checkSlimline);
//       }
//     }, 200); // check every 200ms

//     // 3️⃣ Remove v=s from URL after 5 seconds
//     setTimeout(function() {
//       const params = new URLSearchParams(window.location.search);
//       params.delete('v');
//       const newUrl = params.toString()
//         ? window.location.pathname + '?' + params.toString()
//         : window.location.pathname;
//       history.replaceState(null, '', newUrl);
//     }, 1000); // 5 seconds
//   }

// }); 


/* add class on other pages not home */
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname !== "/") {
    console.log("This script runs on all pages except homepage!");
    document.body.classList.add("not-homepage");
  }
});


/* mobile footer accordian */
(function () {
  let isAutoClosing = false;

  function initFooterOneOpen() {
    const footer = document.querySelector(".site-footer, .footer, footer");
    if (!footer) return;

    // bind only once
    if (footer.__oneOpenBound) return;
    footer.__oneOpenBound = true;

    footer.addEventListener("click", function (e) {
      const btn = e.target.closest("button.collapsible-trigger[aria-controls]");
      if (!btn || !footer.contains(btn)) return;

      if (isAutoClosing) return;

      // Theme pehle is button ko open/close karega, so we wait 0ms
      setTimeout(() => {
        const opened = btn.getAttribute("aria-expanded") === "true";
        if (!opened) return;

        // close other opened ones using theme behavior (click)
        const openBtns = footer.querySelectorAll(
          "button.collapsible-trigger[aria-controls][aria-expanded='true']"
        );

        isAutoClosing = true;
        openBtns.forEach((other) => {
          if (other !== btn) other.click();
        });
        isAutoClosing = false;
      }, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFooterOneOpen);
  } else {
    initFooterOneOpen();
  }

  // Shopify sections/ajax re-render safe
  const obs = new MutationObserver(() => initFooterOneOpen());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

/* header drawer show logo menu after open drawer menu */
 document.addEventListener("DOMContentLoaded", function() {
  var header = document.getElementById("SiteHeader");
  var stickyWrapper = document.querySelector(".header-sticky-wrapper");
  
  function checkSticky() {
    if (window.scrollY > 50) { // scroll threshold, adjust as needed
      header.classList.add("sticky-bg");
      stickyWrapper.classList.add("sticky-bg");
    } else {
      header.classList.remove("sticky-bg");
      stickyWrapper.classList.remove("sticky-bg");
    }
  }

  window.addEventListener("scroll", checkSticky);
});

(function () {
  function updateHeights() {
    // announcement height
    var announcement = document.querySelector('.announcement-bar, #AnnouncementBar, .site-announcement, .announcement');
    var announcementHeight = announcement ? announcement.offsetHeight : 40;

    // header height
    var header = document.getElementById('SiteHeader') || document.querySelector('header#SiteHeader');
    var headerHeight = header ? header.offsetHeight : 64;

    // set CSS vars
    document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

    // drawer
    var drawer = document.getElementById('NavDrawer') || document.querySelector('.drawer');
    if (drawer) {
      drawer.style.top = (announcementHeight + headerHeight) + 'px';
      drawer.style.height = 'calc(100% - ' + (announcementHeight + headerHeight) + 'px)';
      drawer.style.left = '0';
      drawer.style.right = 'auto';
    }

    // overlay
    var overlays = document.querySelectorAll('.drawer__overlay, .drawer-overlay, .drawer-backdrop');
    overlays.forEach(function (ov) {
      ov.style.top = (announcementHeight + headerHeight) + 'px';
      ov.style.height = 'calc(100% - ' + (announcementHeight + headerHeight) + 'px)';
    });
  }

  // initial
  window.addEventListener('load', updateHeights);

  // on resize
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeights, 120);
  });

  // on hamburger click
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-drawer-open-nav, .site-nav__link--icon')) {
      setTimeout(updateHeights, 50);
    }
  });

  // observe DOM changes
  if (window.MutationObserver) {
    var observer = new MutationObserver(updateHeights);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
  }
})();

/* collection dropdwn products pages */
document.addEventListener("DOMContentLoaded", function () {
(function () {
  const DEBOUNCE_MS = 120;
  let debounceTimer = null;

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function debounceRun(fn) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, DEBOUNCE_MS);
  }

  function closeAllDropdowns(exceptDropdown) {
    document.querySelectorAll(".product-dropdown-block .custom-dropdown.active").forEach((dd) => {
      if (exceptDropdown && dd === exceptDropdown) return;
      dd.classList.remove("active");
      const sel = dd.querySelector(".dropdown-selected");
      if (sel) sel.setAttribute("aria-expanded", "false");
    });
  }

  function ensureHiddenInput(form, propName, value) {
    if (!form || !propName) return;

    let input = form.querySelector(`input[name="${propName.replace(/"/g, '\\"')}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = propName;
      form.appendChild(input);
    }
    input.value = value;
  }

  function setSelectedUI({ dropdown, selectedEl, helperEl, value, img }) {
    selectedEl.innerHTML = img
      ? `<img src="${img}" width="24" height="24" style="border-radius:3px;margin-right:6px;"> ${value}`
      : value;

    if (helperEl) {
      const hc = helperEl.querySelector(".helper-current");
      if (hc) hc.textContent = value;
    }

    dropdown.querySelectorAll(".dropdown-item").forEach((i) => i.classList.remove("selected", "hidden-in-list"));
    const activeItem = dropdown.querySelector(`.dropdown-item[data-value="${CSS.escape(value)}"]`);
    if (activeItem) {
      activeItem.classList.add("selected", "hidden-in-list");
    }
  }

  function initOneWrap(wrap) {
    if (!wrap || wrap.__patternDropdownInited) return;

    const dropdown = wrap.querySelector(".custom-dropdown");
    const selected = dropdown ? dropdown.querySelector(".dropdown-selected") : null;
    const items = dropdown ? Array.from(dropdown.querySelectorAll(".dropdown-item")) : [];
    const helper = wrap.querySelector(".dropdown-helper");

    const form = document.querySelector("form[action='/cart/add']");
    const propName = wrap.getAttribute("data-prop-name") || "";
    const currentTitle = (wrap.getAttribute("data-current-title") || "").trim();

    if (!dropdown || !selected || !items.length || !propName) return;

    // Find active item by currentTitle
    const currentFullTitle = (wrap.getAttribute("data-current-full-title") || "").trim();

// Find active item by FULL title first (Harland (Purple) vs Harland (Green))
let activeItem = items.find((i) => (i.dataset.fullTitle || "").trim() === currentFullTitle);

// Fallback: old matching by base title
if (!activeItem) {
  activeItem = items.find((i) => (i.dataset.value || "").trim() === currentTitle);
}


    // Fallback: hidden input value
    let hiddenInput = form ? form.querySelector(`input[name="${propName.replace(/"/g, '\\"')}"]`) : null;
    let valueFromHidden = hiddenInput ? hiddenInput.value : null;

    if (!activeItem && valueFromHidden) {
      const matched = items.find((i) => (i.dataset.value || "").trim() === valueFromHidden.trim());
      if (matched) activeItem = matched;
    }

    // Fallback: first item
    if (!activeItem) activeItem = items[0];

    // Initial UI + hidden input
    if (activeItem) {
      const val = (activeItem.dataset.value || activeItem.querySelector("span")?.innerText || "").trim();
      const img = activeItem.dataset.image || "";

      selected.innerHTML = img
        ? `<img src="${img}" width="24" height="24" style="border-radius:3px;margin-right:6px;"> ${val}`
        : val;

      if (helper) {
        const hc = helper.querySelector(".helper-current");
        if (hc) hc.textContent = val;
      }

      ensureHiddenInput(form, propName, val);

      items.forEach((i) => i.classList.remove("selected", "hidden-in-list"));
      activeItem.classList.add("selected", "hidden-in-list");
    }

    // Mark inited
    wrap.__patternDropdownInited = true;
  }

  function initAllWraps() {
    document.querySelectorAll(".product-dropdown-block[data-prop-name][data-current-title]").forEach(initOneWrap);
  }

  onReady(function () {
    // Init now
    initAllWraps();

    // Toggle dropdown (parent based delegation)
    document.addEventListener("click", function (e) {
      const sel = e.target.closest(".product-dropdown-block .dropdown-selected");
      if (sel) {
        e.stopPropagation();
        const wrap = sel.closest(".product-dropdown-block");
        const dropdown = wrap ? wrap.querySelector(".custom-dropdown") : null;
        if (!dropdown) return;

        const willOpen = !dropdown.classList.contains("active");
        closeAllDropdowns(dropdown);

        dropdown.classList.toggle("active", willOpen);
        sel.setAttribute("aria-expanded", willOpen ? "true" : "false");
        return;
      }

      // Item click (parent based delegation)
      const item = e.target.closest(".product-dropdown-block .dropdown-item");
      if (item) {
        e.stopPropagation();

        const wrap = item.closest(".product-dropdown-block");
        const dropdown = wrap ? wrap.querySelector(".custom-dropdown") : null;
        const selected = dropdown ? dropdown.querySelector(".dropdown-selected") : null;
        const helper = wrap ? wrap.querySelector(".dropdown-helper") : null;
        const form = document.querySelector("form[action='/cart/add']");
        const propName = wrap ? (wrap.getAttribute("data-prop-name") || "") : "";

        if (!dropdown || !selected || !propName) return;

        const url = item.dataset.url;
        const value = (item.dataset.value || "").trim();
        const variantId = item.dataset.variant;
        const img = item.dataset.image || "";

        ensureHiddenInput(form, propName, value);

        // Update UI
        selected.innerHTML = img
          ? `<img src="${img}" width="24" height="24" style="border-radius:3px;margin-right:6px;"> ${value}`
          : value;

        if (helper) {
          const hc = helper.querySelector(".helper-current");
          if (hc) hc.textContent = value;
        }

        dropdown.querySelectorAll(".dropdown-item").forEach((i) => i.classList.remove("selected", "hidden-in-list"));
        item.classList.add("selected", "hidden-in-list");

        dropdown.classList.remove("active");
        selected.setAttribute("aria-expanded", "false");

        // Redirect (same as before)
        if (url && variantId && window.location.pathname !== url) {
          window.location.href = `${url}?variant=${variantId}`;
        }
        return;
      }

      // Outside click => close all
      if (!e.target.closest(".product-dropdown-block")) {
        closeAllDropdowns();
      }
    });

    // Re-init on DOM updates (Shopify sections)
    const obs = new MutationObserver(function () {
      debounceRun(initAllWraps);
    });
    obs.observe(document.body, { childList: true, subtree: true });

    // Optional custom events (same behavior)
    window.addEventListener("cart:refresh", function () { debounceRun(initAllWraps); });
    window.addEventListener("cart:updated", function () { debounceRun(initAllWraps); });
  });
})();
});


  document.addEventListener("DOMContentLoaded", function () {
    document.body.classList.add("cstm-loaded");
  });


/* ===== Cart Offer Summary (NO refresh) =====
   Updates:
   - #CartOfferSummaryLabel  (2-piece / 6-piece / 3 sets / 4 sets)
   - #CartOfferSummaryAmount (-$X.XX)
   Based on:
   - existing item-level discount lines (cart__discount) OR
   - discount allocation text already printed per item
   And counts quantities to decide 2 vs 6 etc.
*/

(function () {

  function getOfferGroupFromWrap(wrap) {
    return (wrap && wrap.getAttribute('data-offer-group')) || '';
  }

  function parseMoneyToCents(txt) {
    if (!txt) return 0;
    const n = parseFloat(String(txt).replace(/[^0-9.-]/g, ''));
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function formatMoneyFromCents(cents) {
    const abs = Math.abs(cents);
    return '$' + (abs / 100).toFixed(2);
  }

  function extractDiscountCents(text) {
    const m = String(text || '').match(/-?\$\s*[\d,.]+/g);
    if (!m || !m.length) return 0;
    const last = m[m.length - 1];
    return Math.abs(parseMoneyToCents(last));
  }

  function hasRealDiscount(wrap) {
    const orig = parseInt(wrap.getAttribute('data-orig-cents') || '0', 10);
    const fin  = parseInt(wrap.getAttribute('data-final-cents') || '0', 10);
    if (!isNaN(orig) && !isNaN(fin) && fin < orig) return true;
    return !!wrap.querySelector('.js-discount-lines .cart__discount');
  }

  function getOfferSavingsCents() {
    let total = 0;
    document.querySelectorAll('.cart__discount').forEach(el => {
      total += extractDiscountCents(el.textContent || '');
    });
    return total;
  }

  // Count ALL discount rows (not unique)
  function getAppliedDiscountCount() {
    let count = 0;
    document.querySelectorAll('.cart__discount').forEach(el => {
      const txt = (el.textContent || '').trim();
      const cents = extractDiscountCents(txt);
      if (txt && cents > 0) count += 1;
    });
    return count;
  }

  function getLiveQtyForItem(priceCol) {
    if (!priceCol) return 0;
    const key = priceCol.getAttribute('data-item-key');
    if (!key) return 0;

    const input = document.querySelector('.js-qty__num[data-id="' + CSS.escape(key) + '"]');
    if (input && input.value) {
      const n = parseInt(input.value, 10);
      return isNaN(n) ? 0 : n;
    }

    const attr = priceCol.getAttribute('data-qty');
    const m = parseInt(attr || '0', 10);
    return isNaN(m) ? 0 : m;
  }

  // Thresholds (labels only)
  function getQualifyCount(group, totalQty) {
    if (group === 'can') return totalQty >= 6 ? 6 : 0;
    if (group === 'style') return totalQty >= 3 ? 3 : 0;
    return 0;
  }
    function labelFor(group, qualifyCount, start, end) {
      if (group === 'can') return `Buy 5 Get 1 Free Offer`;
      if (group === 'style') return `3-set offer applied to eligible items`;
      return '';
    }

    function genericLabel(group) {
      if (group === 'can') return 'Buy 5 Get 1 Free Offer';
      if (group === 'style') return '3-set offer applied to eligible items';
      return '';
    }

  // function genericLabel(group) {
  //   if (group === 'can') return 'Included in 6-piece offer';
  //   if (group === 'style') return 'Included in 3 sets offer';
  //   return '';
  // }

  function allocateUnitsAcrossLines(items, qualifyUnits) {
    items.sort((a, b) => a.index - b.index);

    let remaining = qualifyUnits;
    let cursor = 1;
    const usedMap = new Map();

    for (const it of items) {
      if (remaining <= 0) break;

      const use = Math.min(it.qty, remaining);
      if (use > 0) {
        const start = cursor;
        const end = cursor + use - 1;
        usedMap.set(it.key, { use, start, end });
        cursor = end + 1;
        remaining -= use;
      }
    }

    return usedMap;
  }

  function updateOfferSummary() {
    const labelEl = document.getElementById('CartOfferSummaryLabel');
    const amtEl = document.getElementById('CartOfferSummaryAmount');
    const row = document.querySelector('#CartOfferSummary .cart__offer-row');
    if (!labelEl || !amtEl || !row) return;

    const savingsCents = getOfferSavingsCents();
    const discountCount = getAppliedDiscountCount();

    if (savingsCents <= 0 || discountCount <= 0) {
      row.style.display = 'none';
      labelEl.textContent = '';
      amtEl.textContent = '';
      return;
    }

    row.style.display = '';
    labelEl.textContent = `Savings included in subtotal`;
    labelEl.style.color = 'rgba(0,0,0,0.6)';
    amtEl.textContent = '-' + formatMoneyFromCents(savingsCents);
  }

  function updateCartOfferUI() {
    const wraps = Array.from(document.querySelectorAll('.cart__price-wrap[data-offer-group]'));
    if (!wraps.length) return;

    const grouped = { can: [], style: [], bottle: [], other: [] };

    wraps.forEach((wrap, idx) => {
      const priceCol = wrap.closest('.cart__item-price-col');
      const key = priceCol ? priceCol.getAttribute('data-item-key') : '';
      const group = getOfferGroupFromWrap(wrap) || 'other';
      const qty = getLiveQtyForItem(priceCol);
      const discounted = hasRealDiscount(wrap);

      (grouped[group] || grouped.other).push({ wrap, priceCol, key, qty, index: idx, discounted });
    });

    ['can', 'style', 'bottle'].forEach(group => {
      const items = grouped[group] || [];

      const totalQty = items.reduce((s, x) => s + (x.qty || 0), 0);
      const qualifyUnits = getQualifyCount(group, totalQty);

      // only discounted items get numbered allocation (first qualify block)
      const discountedItems = items.filter(x => x.discounted);
      const usedMap = (group === 'bottle' || qualifyUnits === 0)
        ? new Map()
        : allocateUnitsAcrossLines(discountedItems, qualifyUnits);

      items.forEach(it => {
        const wrap = it.wrap;
        const labelEl = wrap.querySelector('.js-offer-label');
        const discLines = wrap.querySelector('.js-discount-lines');
        const origSpan = wrap.querySelector('.js-price-original');
        const discSpan = wrap.querySelector('.js-price-discounted');

        wrap.classList.remove('is-qualifying', 'is-not-qualifying');

        // If discount exists -> ALWAYS treat as qualifying (fix faux-fur layout)
        if (it.discounted) {
          wrap.classList.add('is-qualifying');

          if (discLines) discLines.style.display = '';
          if (origSpan) { origSpan.style.display = 'block'; origSpan.style.textDecoration = 'line-through'; }
          if (discSpan) { discSpan.style.display = 'block'; }

          // label: numbered if available, otherwise generic (same styling)
          const meta = usedMap.get(it.key);
          if (labelEl) {
            const txt = genericLabel(group);

            labelEl.textContent = txt;
            labelEl.style.display = 'block';
            labelEl.style.color = 'rgba(0,0,0,0.6)';
          }

        } else {
          // no discount
          wrap.classList.add('is-not-qualifying');

          if (labelEl) { labelEl.style.display = 'none'; labelEl.textContent = ''; }
          if (discLines) discLines.style.display = 'none';

          if (origSpan) { origSpan.style.display = 'block'; origSpan.style.textDecoration = 'none'; }
          if (discSpan) { discSpan.style.display = 'none'; }
        }

        // if not qualified threshold (qty below 6/3), still show real discount if exists (handled above)
        if (group !== 'bottle' && qualifyUnits === 0 && !it.discounted) {
          // already handled as not-qualifying
        }
      });
    });

    updateOfferSummary();
  }

  let t = null;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(updateCartOfferUI, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    schedule();
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-qty__adjust')) schedule();
  });

  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('js-qty__num')) schedule();
  });

})();




/* =========================================================
  Continue Shopping -> last viewed product
  - Uses your button wrapper: .cart-button a[href="/collections/shop"]
  - Uses cart top item link: .cart__item:first-child a[href*="/products/"]
  - Stores last product URL in sessionStorage while browsing
========================================================= */

/* 1) Put this on ALL pages (theme.liquid before </body> is best) */
(function () {
  function isProductUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname.startsWith('/products/');
    } catch (e) {
      return false;
    }
  }

  function saveLastProduct(url) {
    if (!url || !isProductUrl(url)) return;
    sessionStorage.setItem('last_product_url', url);
  }

  // If currently on product page
  if (window.location.pathname.indexOf('/products/') === 0) {
    saveLastProduct(window.location.href);
  }

  // Also capture product clicks anywhere
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href]');
    if (!a) return;

    const href = a.getAttribute('href');
    if (!href || href.indexOf('#') === 0) return;

    // Support relative links
    const abs = new URL(href, window.location.origin).href;
    if (isProductUrl(abs)) saveLastProduct(abs);
  }, true);
})();


/* 2) Put this on CART page (or inside your existing cart JS) */
(function () {

  function getFirstCartItemProductUrl() {
    const firstItem = document.querySelector('.cart__item');
    if (!firstItem) return '';
    const a = firstItem.querySelector('a[href^="/products/"], a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }

  function setContinueShoppingHref() {
    const link = document.querySelector('.cart-button a[href]');
    if (!link) return;

    const firstCartHref = getFirstCartItemProductUrl();

    // ✅ Priority: CURRENT top cart item
    if (firstCartHref) {
      link.setAttribute('href', firstCartHref);

      // optional: keep storage updated too
      try {
        const abs = new URL(firstCartHref, window.location.origin).href;
        sessionStorage.setItem('last_product_url', abs);
      } catch (e) {}

      return;
    }

    // ✅ If cart empty → fallback
    link.setAttribute('href', '/collections/shop');
  }

  let t = null;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(setContinueShoppingHref, 100);
  }

  document.addEventListener('DOMContentLoaded', function () {
    schedule();
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-qty__adjust') || e.target.closest('a[href*="/cart/"]')) schedule();
  });

  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('js-qty__num')) schedule();
  });

})();


// free shipping cart
// (function () {
//   const SELECTOR = '[data-free-shipping-message]';

//   function setVisible(el, show) {
//     el.style.display = show ? 'block' : 'none';
//   }

//   function updateFreeShippingFromCart(cart) {
//     const el = document.querySelector(SELECTOR);
//     if (!el) return;

//     const threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
//     const total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;

//     setVisible(el, total >= threshold);
//   }

//   async function refreshCartAndUpdateMessage() {
//     try {
//       const res = await fetch('/cart.js', { credentials: 'same-origin' });
//       if (!res.ok) return;
//       const cart = await res.json();
//       updateFreeShippingFromCart(cart);
//     } catch (e) {
//       // ignore
//     }
//   }

//   // Run once on load
//   document.addEventListener('DOMContentLoaded', refreshCartAndUpdateMessage);

//   // ---- Detect Shopify cart AJAX updates (fetch + XHR) ----

//   // Hook fetch
//   const originalFetch = window.fetch;
//   window.fetch = function (...args) {
//     return originalFetch.apply(this, args).then((res) => {
//       try {
//         const input = args[0];
//         const url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';

//         // Typical cart endpoints
//         const isCartCall =
//           url.includes('/cart/change') ||
//           url.includes('/cart/update') ||
//           url.includes('/cart/add') ||
//           url.includes('/cart.js') ||
//           url.includes('/cart?') ||
//           url.includes('sections=');

//         if (isCartCall) {
//           // Wait for DOM updates if theme re-renders sections
//           setTimeout(refreshCartAndUpdateMessage, 120);
//         }
//       } catch (e) {}
//       return res;
//     });
//   };

//   // Hook XHR
//   const origOpen = XMLHttpRequest.prototype.open;
//   XMLHttpRequest.prototype.open = function (method, url) {
//     this.addEventListener('load', function () {
//       try {
//         if (!url) return;

//         const isCartCall =
//           url.includes('/cart/change') ||
//           url.includes('/cart/update') ||
//           url.includes('/cart/add') ||
//           url.includes('/cart.js') ||
//           url.includes('/cart?') ||
//           url.includes('sections=');

//         if (isCartCall) {
//           setTimeout(refreshCartAndUpdateMessage, 120);
//         }
//       } catch (e) {}
//     });

//     return origOpen.apply(this, arguments);
//   };

//   // Optional: if theme triggers a custom event
//   document.addEventListener('cart:updated', refreshCartAndUpdateMessage);

  
// })();
(function () {
  const SELECTOR = '[data-free-shipping-message]';

  function updateFreeShippingFromCart(cart) {
    const el = document.querySelector(SELECTOR);
    if (!el) return;

    const threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
    const defaultMessage =
      el.getAttribute('data-default-message') ||
      'Free shipping in Australia on orders $130+.';
    const successMessage =
      el.getAttribute('data-success-message') ||
      "Great news! You've qualified for free shipping in Australia.";

    const total =
      cart && typeof cart.total_price === 'number'
        ? cart.total_price
        : 0;

    el.textContent = total >= threshold ? successMessage : defaultMessage;
    el.style.display = 'block';
  }

  async function refreshCartAndUpdateMessage() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      updateFreeShippingFromCart(cart);
    } catch (e) {
      // ignore
    }
  }

  function isCartCall(url) {
    if (!url || typeof url !== 'string') return false;

    return (
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/add') ||
      url.includes('/cart.js') ||
      url.includes('/cart?') ||
      url.includes('sections=')
    );
  }

  document.addEventListener('DOMContentLoaded', refreshCartAndUpdateMessage);

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    return originalFetch.apply(this, args).then((res) => {
      try {
        const input = args[0];
        const url =
          typeof input === 'string'
            ? input
            : input && input.url
            ? input.url
            : '';

        if (isCartCall(url)) {
          setTimeout(refreshCartAndUpdateMessage, 120);
        }
      } catch (e) {
        // ignore
      }

      return res;
    });
  };

  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      try {
        if (isCartCall(url)) {
          setTimeout(refreshCartAndUpdateMessage, 120);
        }
      } catch (e) {
        // ignore
      }
    });

    return origOpen.apply(this, arguments);
  };

  document.addEventListener('cart:updated', refreshCartAndUpdateMessage);
})();

/* =========================
   BUILD YOUR WARDROBE (BW)
   + Quick Add Modal
   + ✅ Qty +/- handler added (data-bw-qty-minus / data-bw-qty-plus)
========================= */
(() => {
  const section = document.querySelector('[data-bw-section]');
  if (!section) return;

  const modal = section.querySelector('[data-bw-modal]');
  if (!modal) return;

  const btns = section.querySelectorAll('[data-bw-quickadd]');

  const elImg = modal.querySelector('[data-bw-img]');
  const elTitleLink = modal.querySelector('[data-bw-titlelink]');
  const elPrice = modal.querySelector('[data-bw-price]');
  const elQty = modal.querySelector('[data-bw-qty]');
  const elCTA = modal.querySelector('[data-bw-cta]');
  const elSoldout = modal.querySelector('[data-bw-soldout]');
  const elMsg = modal.querySelector('[data-bw-msg]');

  const elFitWrap = modal.querySelector('[data-bw-fit]');
  const elFitBtnsWrap = modal.querySelector('[data-bw-fit-buttons]');
  const elFitHint = modal.querySelector('[data-bw-fit-hint]');

  let currentProduct = null;
  let selectedVariantId = null;
  let fitRequired = false;
  let selectedFit = null;

  // ---- Money formatter ----
  const money = (cents) => {
    const amount = (Number(cents) / 100).toFixed(2);
    const currency = window.Shopify?.currency?.active || 'USD';

    if (currency === 'AUD') return '$' + amount;
    if (currency === 'USD') return '$' + amount;

    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    } catch (e) {
      return amount;
    }
  };

  const openModal = () => {
    modal.hidden = false;
    document.documentElement.classList.add('bw-modal-open');
  };

  const closeModal = () => {
    modal.hidden = true;
    document.documentElement.classList.remove('bw-modal-open');

    currentProduct = null;
    selectedVariantId = null;
    fitRequired = false;
    selectedFit = null;

    if (elFitWrap) elFitWrap.hidden = true;
    if (elFitHint) {
      elFitHint.hidden = true;
      elFitHint.style.display = 'none';
    }

    if (elCTA) elCTA.disabled = true;
    if (elSoldout) elSoldout.hidden = true;

    if (elMsg) {
      elMsg.hidden = true;
      elMsg.textContent = '';
    }

    if (elQty) elQty.value = 1;
    if (elFitBtnsWrap) elFitBtnsWrap.innerHTML = '';
  };

  // ✅ Qty + / - (BW)
  // modal.addEventListener('click', (e) => {
  //   const minus = e.target.closest('[data-bw-qty-minus]');
  //   const plus  = e.target.closest('[data-bw-qty-plus]');
  //   if (!minus && !plus) return;

  //   const wrap = e.target.closest('[data-bw-qty-wrap]');
  //   if (!wrap) return;

  //   const input = wrap.querySelector('[data-bw-qty]');
  //   if (!input) return;

  //   const current = parseInt(input.value || '1', 10) || 1;
  //   const next = minus ? Math.max(1, current - 1) : current + 1;

  //   input.value = String(next);
  //   input.dispatchEvent(new Event('change', { bubbles: true }));
  // });

  modal.addEventListener('click', (e) => {
    if (e.target.matches('[data-bw-close]')) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (!modal.hidden && e.key === 'Escape') closeModal();
  });

  const detectFitOptionIndex = (product) => {
    const options = (product && product.options) ? product.options : [];

    let idx = options.findIndex((o) => String(o).trim().toLowerCase().includes('fit'));
    if (idx !== -1) return idx;

    const commonFitValues = new Set(['standard', 'slimline', 'slim', 'regular', 'classic']);
    const variants = product && product.variants ? product.variants : [];

    for (let i = 0; i < 3; i++) {
      const hasFitLike = variants.some(v => {
        const val = v && v.options ? v.options[i] : null;
        return val && commonFitValues.has(String(val).trim().toLowerCase());
      });
      if (hasFitLike) return i;
    }

    return -1;
  };

  const setCTAState = () => {
    if (!elCTA) return;
    if (!currentProduct) { elCTA.disabled = true; return; }
    if (!currentProduct.available) { elCTA.disabled = true; return; }
    if (fitRequired && !selectedFit) { elCTA.disabled = true; return; }
    if (!selectedVariantId) { elCTA.disabled = true; return; }
    elCTA.disabled = false;
  };

  const buildFitButtons = (product) => {
    if (!elFitBtnsWrap) return;

    const fitIndex = detectFitOptionIndex(product);
    if (fitIndex === -1) {
      elFitBtnsWrap.innerHTML = '';
      return;
    }

    const variants = product && product.variants ? product.variants : [];

    const seen = new Set();
    const values = [];
    variants.forEach((v) => {
      const val = v && v.options ? v.options[fitIndex] : null;
      if (val && !seen.has(val)) {
        seen.add(val);
        values.push(val);
      }
    });

    elFitBtnsWrap.innerHTML = values.map((val) => {
      const safeVal = String(val).replace(/"/g, '&quot;');
      return `<button type="button" class="bw-fit-btn" data-fit="${safeVal}">${val}</button>`;
    }).join('');
  };

  const updateFitButtonsAvailability = (product) => {
    if (!elFitBtnsWrap) return;

    const fitIndex = detectFitOptionIndex(product);
    if (fitIndex === -1) return;

    const buttons = elFitBtnsWrap.querySelectorAll('.bw-fit-btn');
    buttons.forEach((btn) => {
      const val = btn.getAttribute('data-fit');

      const anyAvailable = (product.variants || []).some((v) => {
        const opt = v && v.options ? v.options[fitIndex] : null;
        return String(opt) === String(val) && v.available;
      });

      if (!anyAvailable) {
        btn.classList.add('is-disabled');
        btn.disabled = true;
      } else {
        btn.classList.remove('is-disabled');
        btn.disabled = false;
      }
    });
  };

  const setVariantFromFit = (product, fitValue) => {
    const fitIndex = detectFitOptionIndex(product);
    if (fitIndex === -1) return null;

    const v = (product.variants || []).find((variant) => {
      const opt = variant && variant.options ? variant.options[fitIndex] : null;
      return String(opt) === String(fitValue) && variant.available;
    });

    return v ? v.id : null;
  };

  const setPriceFromVariant = (variant) => {
    if (!variant || !elPrice) return;
    elPrice.innerHTML = money(variant.price);
  };

  const activateFitButton = (fitValue) => {
    if (!elFitBtnsWrap) return;
    elFitBtnsWrap.querySelectorAll('.bw-fit-btn').forEach((x) => {
      x.classList.toggle('is-active', String(x.getAttribute('data-fit')) === String(fitValue));
    });
  };

  const autoSelectFirstAvailableVariant = (product) => {
    const firstAvail = (product.variants || []).find(v => v.available);
    if (!firstAvail) return;

    selectedVariantId = firstAvail.id;

    const fitIndex = detectFitOptionIndex(product);
    if (fitIndex !== -1) {
      selectedFit = firstAvail.options ? firstAvail.options[fitIndex] : null;
      activateFitButton(selectedFit);
    }

    setPriceFromVariant(firstAvail);
    setCTAState();
  };

  const loadProduct = async (handle, productUrl) => {
    if (elCTA) elCTA.disabled = true;
    if (elSoldout) elSoldout.hidden = true;
    if (elMsg) { elMsg.hidden = true; elMsg.textContent = ''; }
    if (elFitHint) { elFitHint.hidden = true; elFitHint.style.display = 'none'; }
    if (elFitBtnsWrap) elFitBtnsWrap.innerHTML = '';

    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Failed to load product.js');
    const product = await res.json();

    currentProduct = product;

    if (elImg) {
      elImg.src = product.featured_image || '';
      elImg.alt = product.title || '';
    }
    if (elTitleLink) {
      elTitleLink.textContent = product.title || '';
      elTitleLink.href = productUrl || `/products/${handle}`;
    }
    if (elPrice) elPrice.innerHTML = money(product.price);

    if (!product.available) {
      if (elSoldout) elSoldout.hidden = false;
      selectedVariantId = null;
      fitRequired = false;
      selectedFit = null;
      if (elFitWrap) elFitWrap.hidden = true;
      setCTAState();
      return;
    }

    const fitIndex = detectFitOptionIndex(product);
    fitRequired = fitIndex !== -1;

    if (fitRequired) {
      if (elFitWrap) elFitWrap.hidden = false;

      selectedFit = null;
      selectedVariantId = null;

      buildFitButtons(product);
      updateFitButtonsAvailability(product);

      autoSelectFirstAvailableVariant(product);
    } else {
      if (elFitWrap) elFitWrap.hidden = true;

      const v = (product.variants || []).find((v) => v.available) || (product.variants ? product.variants[0] : null);
      selectedVariantId = v ? v.id : null;

      setPriceFromVariant(v);
      setCTAState();
    }
  };

  btns.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-product-handle');
      const productUrl = btn.getAttribute('data-product-url');

      openModal();

      try {
        await loadProduct(handle, productUrl);
      } catch (err) {
        if (elMsg) {
          elMsg.hidden = false;
          elMsg.textContent = 'Unable to load product. Please try again.';
        }
        if (elCTA) elCTA.disabled = true;
      }
    });
  });

  if (elFitBtnsWrap) {
    elFitBtnsWrap.addEventListener('click', (e) => {
      const b = e.target.closest('.bw-fit-btn');
      if (!b || b.disabled) return;

      selectedFit = b.getAttribute('data-fit');

      elFitBtnsWrap.querySelectorAll('.bw-fit-btn').forEach((x) => x.classList.remove('is-active'));
      b.classList.add('is-active');

      selectedVariantId = setVariantFromFit(currentProduct, selectedFit);

      if (!selectedVariantId) {
        if (elCTA) elCTA.disabled = true;
        return;
      }

      const vObj = (currentProduct.variants || []).find(v => String(v.id) === String(selectedVariantId));
      setPriceFromVariant(vObj);

      setCTAState();
    });
  }

  if (elCTA) {
    elCTA.addEventListener('click', async () => {
      if (!selectedVariantId || elCTA.disabled) return;

      const qty = Math.max(1, parseInt(elQty ? (elQty.value || '1') : '1', 10));

      const oldText = elCTA.textContent;
      elCTA.disabled = true;
      elCTA.setAttribute('aria-busy', 'true');
      elCTA.textContent = 'ADDING...';

      if (elMsg) { elMsg.hidden = true; elMsg.textContent = ''; }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: qty }] })
        });

        if (!res.ok) throw new Error('Add failed');

        closeModal();

        const opened = openCartDrawer();

        setTimeout(() => {
          if (window.jQuery) {
            const $ = window.jQuery;
            $('#CartDrawer form.ajaxcart .js-qty__num').first().trigger('change');
          } else {
            const qtyEl = document.querySelector('#CartDrawer form.ajaxcart .js-qty__num');
            if (qtyEl) qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 150);

        if (!opened) {
          try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            const bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
            if (bubble) bubble.textContent = cart.item_count;
          } catch(e) {}
        }

      } catch (err) {
        elCTA.textContent = oldText;
        elCTA.disabled = false;
        elCTA.removeAttribute('aria-busy');

        if (elMsg) {
          elMsg.hidden = false;
          elMsg.textContent = 'Could not add to bag. Please try again.';
        }
        setCTAState();
      }
    });
  }

  function openCartDrawer() {
    if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
      window.theme.cartDrawer.open();
      return true;
    }

    const opener =
      document.querySelector('.js-drawer-open-cart') ||
      document.querySelector('button[aria-controls="CartDrawer"]') ||
      document.querySelector('button[data-drawer-open="CartDrawer"]') ||
      document.querySelector('button[data-cart-drawer-open]');

    if (opener) {
      opener.click();
      return true;
    }

    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return false;

    cartDrawer.classList.add('drawer--is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('js-drawer-open');
    document.body.classList.add('js-drawer-open');

    return true;
  }
})();

(function () {
  const DEBUG = true;

  function log() {
    if (DEBUG) console.log.apply(console, ['[SIW]'].concat([].slice.call(arguments)));
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(async function () {
    if (window.location.search.indexOf('cart_refresh=1') > -1) {
      window.history.replaceState({}, document.title, window.location.pathname);
      window.scrollTo(0, 0);
    }

    const root = document.querySelector('[data-siw]');
    if (!root) {
      log('No root');
      return;
    }

    const grid = root.querySelector('[data-siw-grid]');
    const indexEl = document.querySelector('[data-siw-index]');

    if (!grid || !indexEl) {
      log('Missing grid/index');
      return;
    }

    const modal = root.querySelector('[data-siw-modal]');
    const elImg = modal ? modal.querySelector('[data-siw-img]') : null;
    const elTitleLink = modal ? modal.querySelector('[data-siw-titlelink]') : null;
    const elPrice = modal ? modal.querySelector('[data-siw-price]') : null;
    const elQty = modal ? modal.querySelector('[data-siw-qty]') : null;
    const elCTA = modal ? modal.querySelector('[data-siw-cta]') : null;
    const elCheckout = modal ? modal.querySelector('[data-siw-checkout]') : null;
    const elSoldout = modal ? modal.querySelector('[data-siw-soldout]') : null;
    const elMsg = modal ? modal.querySelector('[data-siw-msg]') : null;
    const elFitWrap = modal ? modal.querySelector('[data-siw-fit]') : null;
    const elFitBtnsWrap = modal ? modal.querySelector('[data-siw-fit-buttons]') : null;
    const elFitHint = modal ? modal.querySelector('[data-siw-fit-hint]') : null;

    modal && modal.addEventListener('click', function (e) {
      const minus = e.target.closest('[data-siw-qty-minus]');
      const plus = e.target.closest('[data-siw-qty-plus]');

      if (!minus && !plus) return;

      const wrap = e.target.closest('[data-siw-qty-wrap]');
      if (!wrap) return;

      const input = wrap.querySelector('[data-siw-qty]');
      if (!input) return;

      const current = parseInt(input.value || '1', 10) || 1;
      const next = minus ? Math.max(1, current - 1) : current + 1;

      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    let INDEX;
    try {
      INDEX = JSON.parse(indexEl.textContent || '{}');
    } catch (e) {
      console.error('[SIW] JSON parse error', e);
      return;
    }

    const products = Array.isArray(INDEX.products) ? INDEX.products : [];
    log('Index products:', products.length);

    function getProp(item, key) {
      if (!item || !item.properties) return '';
      return (item.properties[key] || '').toString().trim();
    }

    function uniqueById(arr) {
      const seen = new Set();
      return arr.filter(function (p) {
        if (!p || !p.id || seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      });
    }

    function pickRandom(arr, n) {
      const copy = arr.slice();
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = copy[i];
        copy[i] = copy[j];
        copy[j] = temp;
      }
      return copy.slice(0, n);
    }

    async function fetchCart() {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart fetch failed');
      return await res.json();
    }

    function isFauxItem(it) {
      const m = (getProp(it, '__material') || '').toLowerCase();
      const t = (getProp(it, '__upsell_type') || '').toLowerCase();
      const hasFaux = (getProp(it, '__bundle_has_faux') || '').toLowerCase();

      return (
        m.indexOf('faux') > -1 ||
        t === 'faux_fur' ||
        t === 'bundle_mixed' ||
        hasFaux === 'true'
      );
    }
    function isNeoItem(it) {
      const m = (getProp(it, '__material') || '').toLowerCase();
      const t = (getProp(it, '__upsell_type') || '').toLowerCase();
      const hasCan = (getProp(it, '__bundle_has_can') || '').toLowerCase();

      return (
        m.indexOf('neoprene') > -1 ||
        m.indexOf('can') > -1 ||
        (t === 'can_couture' && m.indexOf('faux') === -1) ||
        t === 'bundle_mixed' ||
        hasCan === 'true'
      );
    }

    function chooseAnchor(cart) {
      const items = cart && cart.items ? cart.items : [];
      if (!items.length) return null;
      return items[0];
    }

    function inferType(anchor) {
      const mat = (getProp(anchor, '__material') || '').toLowerCase();
      const t = (getProp(anchor, '__upsell_type') || '').toLowerCase();

      if (t) return t;
      if (mat.indexOf('faux') > -1) return 'faux_fur';
      if (mat.indexOf('neoprene') > -1) return 'can_couture';
      return '';
    }

    function findProductRecordByCartItem(anchor) {
      const pid = anchor && anchor.product_id ? anchor.product_id : null;
      if (!pid) return null;
      return products.find(function (p) {
        return p.id === pid;
      }) || null;
    }

    function render(list) {
      grid.innerHTML = '';

      list.slice(0, 4).forEach(function (p) {
        const safeTitle = (p.title || '').replace(/"/g, '&quot;');
        const card = document.createElement('div');
        card.className = 'siw-card';

        card.innerHTML =
          '<a class="siw-card__link" href="' + (p.url || '#') + '">' +
            '<div class="siw-card__media">' +
              '<img class="siw-card__img" src="' + (p.image || '') + '" alt="' + safeTitle + '" loading="lazy">' +
            '</div>' +
            '<p class="siw-card__title">' + (p.title || '') + '</p>' +
          '</a>' +

          // '<div class="siw-wishlist">' +
          //   '<button' +
          //     ' aria-label="Add to Wishlist"' +
          //     ' data-with-epi="true"' +
          //     ' class="swym-button swym-add-to-wishlist-view-product product_' + p.id + '"' +
          //     ' data-swaction="addToWishlist"' +
          //     ' data-product-id=\'' + JSON.stringify(p.id) + '\'' +
          //     ' data-variant-id="' + (p.first_variant_id || '') + '"' +
          //     ' data-product-url="' + window.location.origin + (p.url || '') + '">' +
          //   '</button>' +
          // '</div>' +

          '<button' +
            ' type="button"' +
            ' class="siw-quickadd"' +
            ' aria-label="Quick add"' +
            ' data-siw-quickadd' +
            ' data-product-handle="' + (p.handle || '') + '"' +
            ' data-product-url="' + (p.url || '') + '">' +
            '+' +
          '</button>';

        grid.appendChild(card);
      });

      if (window.SwymCallbacks) {
        window.SwymCallbacks.push(function (s) {
          if (s && typeof s.initializeActionButtons === 'function') {
            s.initializeActionButtons();
          }
        });
      }
    }

    
      function getSetProduct(allProducts, cartProductIds) {
        const sets = allProducts.filter(function (p) {
          return p.category === 'sets' && !cartProductIds.has(p.id);
        });

        return sets.length ? sets[0] : null;
      }

      function getFauxProduct(allProducts, cartProductIds, selectedIds) {
        const faux = allProducts.find(function (p) {
          return (
            p.category === 'faux_fur' &&
            !cartProductIds.has(p.id) &&
            !selectedIds.has(p.id)
          );
        });

        return faux || null;
      }

      function buildUpsell(cart) {
        const items = cart && cart.items ? cart.items : [];
        if (!items.length) return [];

        const MAX_ITEMS = 4;

        const cartProductIds = new Set(
          items.map(function (item) {
            return item.product_id;
          })
        );

        const eligible = products.filter(function (p) {
          return p && p.id && !cartProductIds.has(p.id);
        });

        if (!eligible.length) return [];

       const categoryOrder = [
            'can_couture',
            'bottle_couture',
            'style_tiles',
            'sets'
          ];

        const byCategory = {};
        categoryOrder.forEach(function (cat) {
          byCategory[cat] = [];
        });

        eligible.forEach(function (p) {
          const cat = (p.category || p.type || '').toLowerCase();
          if (!byCategory[cat]) byCategory[cat] = [];
          byCategory[cat].push(p);
        });

        const selected = [];
        const selectedIds = new Set();

        function pushIfValid(product) {
          if (!product || !product.id || selectedIds.has(product.id)) return false;
          selected.push(product);
          selectedIds.add(product.id);
          return true;
        }

        // 1. Can, Bottle, Tiles
        categoryOrder.forEach(function (cat) {
          const firstEligible = (byCategory[cat] || []).find(function (p) {
            return !selectedIds.has(p.id);
          });
          if (selected.length < MAX_ITEMS && firstEligible) {
            pushIfValid(firstEligible);
          }
        });

        // 2. Sets special slot
        if (selected.length < MAX_ITEMS) {
          const setProduct = getSetProduct(eligible, cartProductIds);
          pushIfValid(setProduct);
        }

        // 3. Faux as fallback before repeats
        if (selected.length < MAX_ITEMS) {
          const fauxProduct = getFauxProduct(eligible, cartProductIds, selectedIds);
          pushIfValid(fauxProduct);
        }

        // 4. Any remaining unused product
        if (selected.length < MAX_ITEMS) {
          eligible.forEach(function (p) {
            if (selected.length >= MAX_ITEMS) return;
            pushIfValid(p);
          });
        }

        return selected.slice(0, MAX_ITEMS);
      }

    let currentProduct = null;
    let selectedVariantId = null;
    let fitRequired = false;
    let selectedFit = null;

    function money(cents) {
      const amount = (Number(cents) / 100).toFixed(2);
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

      if (currency === 'AUD' || currency === 'USD') {
        return '$' + amount;
      }

      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format(Number(cents) / 100);
      } catch (e) {
        return amount;
      }
    }

    function openModal() {
      if (modal) modal.hidden = false;
    }

    function closeModal() {
      if (!modal) return;

      modal.hidden = true;
      currentProduct = null;
      selectedVariantId = null;
      fitRequired = false;
      selectedFit = null;

      if (elFitWrap) elFitWrap.hidden = true;
      if (elFitHint) {
        elFitHint.hidden = true;
        elFitHint.style.display = 'none';
      }
      if (elCTA) elCTA.disabled = true;
      if (elCheckout) elCheckout.disabled = true;
      if (elSoldout) elSoldout.hidden = true;
      if (elMsg) {
        elMsg.hidden = true;
        elMsg.textContent = '';
      }
      if (elQty) elQty.value = 1;
      if (elFitBtnsWrap) elFitBtnsWrap.innerHTML = '';
    }

    modal && modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-siw-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (modal && !modal.hidden && e.key === 'Escape') {
        closeModal();
      }
    });

    function detectFitOptionIndex(product) {
      const options = product && product.options ? product.options : [];
      let idx = options.findIndex(function (o) {
        return String(o).trim().toLowerCase().indexOf('fit') > -1;
      });
      if (idx !== -1) return idx;

      const common = new Set(['standard', 'slimline', 'slim', 'regular', 'classic']);
      const variants = product && product.variants ? product.variants : [];

      for (let i = 0; i < 3; i++) {
        const hasFitLike = variants.some(function (v) {
          const val = v && v.options ? v.options[i] : null;
          return val && common.has(String(val).trim().toLowerCase());
        });
        if (hasFitLike) return i;
      }

      return -1;
    }

    function setCTAState() {
      const canProceed = !!(currentProduct && currentProduct.available && selectedVariantId && (!fitRequired || selectedFit));

      if (elCTA) elCTA.disabled = !canProceed;
      if (elCheckout) elCheckout.disabled = !canProceed;
    }

    
    function setPriceFromVariant(variant) {
      if (!variant || !elPrice) return;
      elPrice.textContent = money(variant.price);
    }

    function buildFitButtons(product) {
      if (!elFitBtnsWrap) return;

      const fitIndex = detectFitOptionIndex(product);
      if (fitIndex === -1) {
        elFitBtnsWrap.innerHTML = '';
        return;
      }

      const variants = product && product.variants ? product.variants : [];
      const seen = new Set();
      const values = [];

      variants.forEach(function (v) {
        const val = v && v.options ? v.options[fitIndex] : null;
        if (val && !seen.has(val)) {
          seen.add(val);
          values.push(val);
        }
      });

      elFitBtnsWrap.innerHTML = values.map(function (val) {
        const safeVal = String(val).replace(/"/g, '&quot;');
        return '<button type="button" class="bw-fit-btn" data-fit="' + safeVal + '">' + val + '</button>';
      }).join('');
    }

    function updateFitButtonsAvailability(product) {
      if (!elFitBtnsWrap) return;

      const fitIndex = detectFitOptionIndex(product);
      if (fitIndex === -1) return;

      elFitBtnsWrap.querySelectorAll('.bw-fit-btn').forEach(function (btn) {
        const val = btn.getAttribute('data-fit');
        const anyAvailable = (product.variants || []).some(function (v) {
          const opt = v && v.options ? v.options[fitIndex] : null;
          return String(opt) === String(val) && v.available;
        });

        btn.disabled = !anyAvailable;
        btn.classList.toggle('is-disabled', !anyAvailable);
      });
    }

    function activateFitButton(fitValue) {
      if (!elFitBtnsWrap) return;

      elFitBtnsWrap.querySelectorAll('.bw-fit-btn').forEach(function (x) {
        x.classList.toggle('is-active', String(x.getAttribute('data-fit')) === String(fitValue));
      });
    }

    function autoSelectFirstAvailableVariant(product) {
      const firstAvail = (product.variants || []).find(function (v) {
        return v.available;
      });

      if (!firstAvail) return;

      selectedVariantId = firstAvail.id;

      const fitIndex = detectFitOptionIndex(product);
      if (fitIndex !== -1) {
        selectedFit = firstAvail.options ? firstAvail.options[fitIndex] : null;
        activateFitButton(selectedFit);
      }

      setPriceFromVariant(firstAvail);
      setCTAState();
    }

    function setVariantFromFit(product, fitValue) {
      const fitIndex = detectFitOptionIndex(product);
      if (fitIndex === -1) return null;

      const v = (product.variants || []).find(function (variant) {
        const opt = variant && variant.options ? variant.options[fitIndex] : null;
        return String(opt) === String(fitValue) && variant.available;
      });

      return v ? v.id : null;
    }

    async function loadProduct(handle, productUrl) {
      if (elCTA) elCTA.disabled = true;
      if (elCheckout) elCheckout.disabled = true;
      if (elSoldout) elSoldout.hidden = true;
      if (elMsg) {
        elMsg.hidden = true;
        elMsg.textContent = '';
      }
      if (elFitHint) {
        elFitHint.hidden = true;
        elFitHint.style.display = 'none';
      }
      if (elFitBtnsWrap) elFitBtnsWrap.innerHTML = '';

      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('Failed to load product.js');

      const product = await res.json();
      currentProduct = product;

      if (elImg) {
        elImg.src = product.featured_image || '';
        elImg.alt = product.title || '';
      }

      if (elTitleLink) {
        elTitleLink.textContent = product.title || '';
        elTitleLink.href = productUrl || ('/products/' + handle);
      }

      if (!product.available) {
        if (elSoldout) elSoldout.hidden = false;
        selectedVariantId = null;
        fitRequired = false;
        selectedFit = null;
        if (elFitWrap) elFitWrap.hidden = true;
        setCTAState();
        return;
      }

      const fitIndex = detectFitOptionIndex(product);
      fitRequired = fitIndex !== -1;

      if (fitRequired) {
        if (elFitWrap) elFitWrap.hidden = false;

        selectedFit = null;
        selectedVariantId = null;

        buildFitButtons(product);
        updateFitButtonsAvailability(product);
        autoSelectFirstAvailableVariant(product);
      } else {
        if (elFitWrap) elFitWrap.hidden = true;

        const v = (product.variants || []).find(function (variant) {
          return variant.available;
        }) || (product.variants ? product.variants[0] : null);

        selectedVariantId = v ? v.id : null;
        setPriceFromVariant(v);
        setCTAState();
      }
    }

    grid.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-siw-quickadd]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-product-handle');
      const productUrl = btn.getAttribute('data-product-url');

      openModal();

      try {
        await loadProduct(handle, productUrl);
      } catch (err) {
        if (elMsg) {
          elMsg.hidden = false;
          elMsg.textContent = 'Unable to load product. Please try again.';
        }
        if (elCTA) elCTA.disabled = true;
        if (elCheckout) elCheckout.disabled = true;
      }
    });

    elFitBtnsWrap && elFitBtnsWrap.addEventListener('click', function (e) {
      const b = e.target.closest('.bw-fit-btn');
      if (!b || b.disabled) return;

      selectedFit = b.getAttribute('data-fit');

      elFitBtnsWrap.querySelectorAll('.bw-fit-btn').forEach(function (x) {
        x.classList.remove('is-active');
      });

      b.classList.add('is-active');

      selectedVariantId = setVariantFromFit(currentProduct, selectedFit);

      if (!selectedVariantId) {
        if (elCTA) elCTA.disabled = true;
        if (elCheckout) elCheckout.disabled = true;
        return;
      }

      const vObj = (currentProduct.variants || []).find(function (v) {
        return String(v.id) === String(selectedVariantId);
      });

      setPriceFromVariant(vObj);
      setCTAState();
    });

    elCTA && elCTA.addEventListener('click', async function () {
      if (!selectedVariantId || elCTA.disabled) return;

      const qty = Math.max(1, parseInt(elQty ? (elQty.value || '1') : '1', 10));
      const oldText = elCTA.textContent;

      elCTA.disabled = true;
      elCTA.setAttribute('aria-busy', 'true');
      elCTA.textContent = 'ADDING...';

      if (elMsg) {
        elMsg.hidden = true;
        elMsg.textContent = '';
      }

      try {
        const body = new URLSearchParams();
        body.append('id', String(selectedVariantId));
        body.append('quantity', String(qty));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: body.toString()
        });

        const text = await res.text();
        let data = {};

        try {
          data = JSON.parse(text);
        } catch (e) {}

        if (!res.ok) {
          const msg = (data && (data.description || data.message)) || 'Could not add to bag. Please try again.';
          throw new Error(msg);
        }

        closeModal();
        window.location.href = window.location.pathname + '?cart_refresh=1';
        return;
      } catch (err) {
        console.error('[SIW add] failed', err);

        elCTA.textContent = oldText;
        elCTA.disabled = false;
        elCTA.removeAttribute('aria-busy');

        if (elMsg) {
          elMsg.hidden = false;
          elMsg.textContent = (err && err.message) || 'Could not add to bag. Please try again.';
        }

        setCTAState();
      }
    });

 elCheckout && elCheckout.addEventListener('click', async function () {
  if (!selectedVariantId || elCheckout.disabled) return;

  const qty = Math.max(1, parseInt(elQty ? (elQty.value || '1') : '1', 10));
  const oldText = elCheckout.textContent;

  elCheckout.disabled = true;
  elCheckout.setAttribute('aria-busy', 'true');
  elCheckout.textContent = 'PROCESSING...';

  if (elMsg) {
    elMsg.hidden = true;
    elMsg.textContent = '';
  }

  try {
    const body = new URLSearchParams();
    body.append('id', String(selectedVariantId));
    body.append('quantity', String(qty));

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: body.toString()
    });

    const text = await res.text();
    let data = {};

    try {
      data = JSON.parse(text);
    } catch (e) {}

    if (!res.ok) {
      const msg = (data && (data.description || data.message)) || 'Could not proceed to checkout. Please try again.';
      throw new Error(msg);
    }

    window.location.href = '/checkout';
  } catch (err) {
    console.error('[SIW checkout] failed', err);

    elCheckout.textContent = oldText;
    elCheckout.disabled = false;
    elCheckout.removeAttribute('aria-busy');

    if (elMsg) {
      elMsg.hidden = false;
      elMsg.textContent = (err && err.message) || 'Could not proceed to checkout. Please try again.';
    }

    setCTAState();
  }
});

    async function refresh() {
      try {
        const cart = await fetchCart();
        const upsell = buildUpsell(cart);

        if (!upsell || !upsell.length) {
          root.style.display = 'none';
          return;
        }

        root.style.display = '';
        render(upsell);
      } catch (e) {
        console.error('[SIW] refresh error', e);
        root.style.display = 'none';
      }
    }

    window.SIW_refresh = refresh;

    document.addEventListener('siw:cartchanged', function () {
      setTimeout(refresh, 150);
    });

    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(refresh, 150);
      });
    });

    await refresh();

    document.addEventListener('click', function (e) {
      const qtyBtn = e.target && e.target.closest ? e.target.closest('.js-qty__adjust') : null;
      const remove = e.target && e.target.closest ? e.target.closest('.cart__remove a[href*="/cart/change"]') : null;
      if (qtyBtn || remove) setTimeout(refresh, 250);
    }, true);

    document.addEventListener('change', function (e) {
      const el = e.target;
      if (el && (el.matches('.js-qty__num') || el.matches('input[name="updates[]"]'))) {
        setTimeout(refresh, 250);
      }
    }, true);
  });
  (function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents) {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    if (currency === 'USD' || currency === 'AUD') {
      return '$' + amount;
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (e) {
      return amount;
    }
  }

  onReady(function () {
    const sections = document.querySelectorAll('[data-bw-section]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      const modal = section.querySelector('[data-bw-modal]');
      if (!modal) return;

      const quickAddButtons = section.querySelectorAll('[data-bw-quickadd]');
      const closeButtons = modal.querySelectorAll('[data-bw-close]');
      const qtyInput = modal.querySelector('[data-bw-qty]');
      const qtyMinus = modal.querySelector('[data-bw-qty-minus]');
      const qtyPlus = modal.querySelector('[data-bw-qty-plus]');
      const addBtn = modal.querySelector('[data-bw-cta]');
      const checkoutBtn = modal.querySelector('[data-bw-checkout]');
      const msgEl = modal.querySelector('[data-bw-msg]');
      const soldoutEl = modal.querySelector('[data-bw-soldout]');
      const imgEl = modal.querySelector('[data-bw-img]');
      const titleLinkEl = modal.querySelector('[data-bw-titlelink]');
      const priceEl = modal.querySelector('[data-bw-price]');
      const fitWrap = modal.querySelector('[data-bw-fit]');
      const fitButtonsWrap = modal.querySelector('[data-bw-fit-buttons]');
      const fitHint = modal.querySelector('[data-bw-fit-hint]');

      let currentProduct = null;
      let selectedVariant = null;
      let fitOptionIndex = -1;

      function resetMessages() {
        if (msgEl) {
          msgEl.hidden = true;
          msgEl.textContent = '';
        }
        if (soldoutEl) soldoutEl.hidden = true;
        if (fitHint) fitHint.hidden = true;
      }

      function openModal() {
        modal.hidden = false;
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
      }

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden');
        resetMessages();
      }

      function detectFitOptionIndex(product) {
        if (!product || !product.options || !product.options.length) return -1;

        const byName = product.options.findIndex(function (opt) {
          return String(opt || '').toLowerCase().indexOf('fit') > -1;
        });
        if (byName !== -1) return byName;

        const common = ['standard', 'slimline', 'slim', 'regular', 'classic'];
        const variants = product.variants || [];

        for (let i = 0; i < 3; i++) {
          const match = variants.some(function (variant) {
            const value = variant && variant.options ? variant.options[i] : '';
            return common.indexOf(String(value || '').toLowerCase()) > -1;
          });
          if (match) return i;
        }

        return -1;
      }

      function setButtonsState() {
        const canProceed = !!(selectedVariant && selectedVariant.available);

        if (addBtn) addBtn.disabled = !canProceed;
        if (checkoutBtn) checkoutBtn.disabled = !canProceed;

        if (soldoutEl) {
          soldoutEl.hidden = canProceed;
        }
      }

      function setPrice() {
        if (!priceEl) return;
        if (!selectedVariant) {
          priceEl.textContent = '';
          return;
        }
        priceEl.textContent = formatMoney(selectedVariant.price);
      }

      function setMediaAndTitle(product, productUrl) {
        if (imgEl) {
          imgEl.src = product.featured_image || '';
          imgEl.alt = product.title || '';
        }

        if (titleLinkEl) {
          titleLinkEl.textContent = product.title || '';
          titleLinkEl.href = productUrl || ('/products/' + product.handle);
        }
      }

      function activateFitButton(value) {
        if (!fitButtonsWrap) return;

        fitButtonsWrap.querySelectorAll('.bw-fit-btn').forEach(function (btn) {
          btn.classList.toggle('is-active', String(btn.getAttribute('data-fit')) === String(value));
        });
      }

      function buildFitButtons(product) {
        if (!fitWrap || !fitButtonsWrap) return;

        fitOptionIndex = detectFitOptionIndex(product);

        if (fitOptionIndex === -1) {
          fitWrap.hidden = true;
          fitButtonsWrap.innerHTML = '';
          return;
        }

        fitWrap.hidden = false;

        const seen = new Set();
        const values = [];

        (product.variants || []).forEach(function (variant) {
          const value = variant && variant.options ? variant.options[fitOptionIndex] : '';
          if (value && !seen.has(value)) {
            seen.add(value);
            values.push(value);
          }
        });

        fitButtonsWrap.innerHTML = values.map(function (value) {
          const escaped = String(value).replace(/"/g, '&quot;');
          const available = (product.variants || []).some(function (variant) {
            const optionVal = variant && variant.options ? variant.options[fitOptionIndex] : '';
            return String(optionVal) === String(value) && variant.available;
          });

          return '<button type="button" class="bw-fit-btn' + (available ? '' : ' is-disabled') + '" data-fit="' + escaped + '"' + (available ? '' : ' disabled') + '>' + value + '</button>';
        }).join('');
      }

      function autoSelectVariant(product) {
        const firstAvailable = (product.variants || []).find(function (variant) {
          return variant.available;
        }) || (product.variants || [])[0] || null;

        selectedVariant = firstAvailable;

        if (selectedVariant && fitOptionIndex !== -1 && selectedVariant.options) {
          activateFitButton(selectedVariant.options[fitOptionIndex]);
        }

        setPrice();
        setButtonsState();
      }

      async function loadProduct(handle, productUrl) {
        resetMessages();

        if (fitWrap) fitWrap.hidden = true;
        if (fitButtonsWrap) fitButtonsWrap.innerHTML = '';
        if (addBtn) addBtn.disabled = true;
        if (checkoutBtn) checkoutBtn.disabled = true;

        const response = await fetch('/products/' + handle + '.js', {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Failed to load product.');
        }

        currentProduct = await response.json();
        selectedVariant = null;
        fitOptionIndex = -1;

        setMediaAndTitle(currentProduct, productUrl);
        buildFitButtons(currentProduct);
        autoSelectVariant(currentProduct);
      }

      async function addVariantAndGo(nextUrl, triggerBtn, loadingText, errorText) {
        if (!selectedVariant || !selectedVariant.id || triggerBtn.disabled) return;

        resetMessages();

        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10) || 1);
        const oldText = triggerBtn.textContent;

        triggerBtn.disabled = true;
        triggerBtn.textContent = loadingText;
        triggerBtn.setAttribute('aria-busy', 'true');

        try {
          const body = new URLSearchParams();
          body.append('id', String(selectedVariant.id));
          body.append('quantity', String(qty));

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: body.toString()
          });

          const text = await response.text();
          let data = {};

          try {
            data = JSON.parse(text);
          } catch (e) {}

          if (!response.ok) {
            throw new Error((data && (data.description || data.message)) || errorText);
          }

          window.location.href = nextUrl;
        } catch (error) {
          triggerBtn.textContent = oldText;
          triggerBtn.disabled = false;
          triggerBtn.removeAttribute('aria-busy');

          if (msgEl) {
            msgEl.hidden = false;
            msgEl.textContent = error && error.message ? error.message : errorText;
          }

          setButtonsState();
        }
      }

      quickAddButtons.forEach(function (btn) {
        btn.addEventListener('click', async function (e) {
          e.preventDefault();
          e.stopPropagation();

          const handle = btn.getAttribute('data-product-handle');
          const productUrl = btn.getAttribute('data-product-url');

          openModal();

          try {
            await loadProduct(handle, productUrl);
          } catch (error) {
            if (msgEl) {
              msgEl.hidden = false;
              msgEl.textContent = error && error.message ? error.message : 'Unable to load product.';
            }
          }
        });
      });

      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeModal();
        });
      });

      modal.addEventListener('click', function (e) {
        if (e.target === modal.querySelector('[data-bw-close]')) return;
      });

      const overlay = modal.querySelector('.bw-modal__overlay');
      if (overlay) {
        overlay.addEventListener('click', function () {
          closeModal();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });

      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          const current = parseInt(qtyInput.value || '1', 10) || 1;
          qtyInput.value = Math.max(1, current - 1);
        });
      }

      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          const current = parseInt(qtyInput.value || '1', 10) || 1;
          qtyInput.value = current + 1;
        });
      }

      if (fitButtonsWrap) {
        fitButtonsWrap.addEventListener('click', function (e) {
          const btn = e.target.closest('.bw-fit-btn');
          if (!btn || btn.disabled || !currentProduct || fitOptionIndex === -1) return;

          const fitValue = btn.getAttribute('data-fit');

          selectedVariant = (currentProduct.variants || []).find(function (variant) {
            const optionVal = variant && variant.options ? variant.options[fitOptionIndex] : '';
            return String(optionVal) === String(fitValue) && variant.available;
          }) || null;

          activateFitButton(fitValue);
          setPrice();
          setButtonsState();

          if (!selectedVariant && fitHint) {
            fitHint.hidden = false;
          } else if (fitHint) {
            fitHint.hidden = true;
          }
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addVariantAndGo('/cart', addBtn, 'ADDING...', 'Could not add to bag. Please try again.');
        });
      }

      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function () {
          addVariantAndGo('/checkout', checkoutBtn, 'PROCESSING...', 'Could not proceed to checkout. Please try again.');
        });
      }
    });
  });
})();
})();
document.addEventListener("DOMContentLoaded", function () {
    function openNewsletterSection() {
      const form = document.getElementById("newsletter-footer");
      if (!form) return;

      const collapsible = form.closest(".footer__collapsible");
      if (collapsible) {
        collapsible.style.display = "block";
        collapsible.hidden = false;
      }

      const details = form.closest("details");
      if (details) {
        details.open = true;
      }

      setTimeout(function () {
        form.scrollIntoView({ behavior: "smooth", block: "center" });

        setTimeout(function () {
          history.replaceState(null, null, window.location.pathname);
        }, 300);
      }, 200);
    }

    if (window.location.hash === "#newsletter-footer") {
      openNewsletterSection();
    }

    document.querySelectorAll('a[href="/#newsletter-footer"], a[href$="#newsletter-footer"]').forEach(function(link) {
      link.addEventListener("click", function(e) {
        const isHomePage =
          window.location.pathname === "/" || window.location.pathname === "";

        if (isHomePage) {
          e.preventDefault();
          openNewsletterSection();
        }
      });
    });

    window.addEventListener("hashchange", function () {
      if (window.location.hash === "#newsletter-footer") {
        openNewsletterSection();
      }
    });
  });
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.quick-product__btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const modalClass = [...btn.classList].find(c => c.indexOf('js-modal-open-quick-modal-') === 0);
  if (!modalClass) return;

  const modalId = modalClass.replace('js-modal-open-', '');
  const modal = document.getElementById(modalId) || document.querySelector('.' + modalId);

  if (modal) {
    modal.classList.add('is-active');
    modal.removeAttribute('hidden');
  }
});

/* NEW pattern dropdown → cart properties */
document.addEventListener("DOMContentLoaded", function () {
  const form =
    document.querySelector("form[action*='/cart/add']") ||
    document.querySelector("product-form form");

  if (!form) return;

  form.addEventListener("submit", function () {

    // remove old injected inputs
    form.querySelectorAll(".custom-prop").forEach(el => el.remove());

    // loop all pattern inputs
    document.querySelectorAll("[data-pattern-input]").forEach((input) => {
      if (!input.value) return;

      const hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = input.name;
      hidden.value = input.value;
      hidden.className = "custom-prop";

      form.appendChild(hidden);
    });

    // Fit (extra)
    const fit = document.getElementById("can-couture-fit-input");
    if (fit && fit.value) {
      const hiddenFit = document.createElement("input");
      hiddenFit.type = "hidden";
      hiddenFit.name = fit.name;
      hiddenFit.value = fit.value;
      hiddenFit.className = "custom-prop";

      form.appendChild(hiddenFit);
    }
  });
});

//collections page reviews
document.addEventListener('DOMContentLoaded', function () {

  function updateCollectionReviewSummary() {
    var wrapper = document.querySelector('.collection-review-summary');
    var textEl = document.querySelector('.summary-text');
    var sources = document.querySelectorAll('.collection-review-source');

    if (!wrapper || !textEl || !sources.length) return;

   var totalReviews = 0;
    var totalRatingValue = 0;
    var countedKeys = [];

    sources.forEach(function (source) {
      var group = source.getAttribute('data-review-group') || 'default';
      var badge = source.querySelector('.jdgm-prev-badge');

      if (!badge) return;

      var rating = parseFloat(badge.getAttribute('data-average-rating')) || 0;
      var count = parseInt(badge.getAttribute('data-number-of-reviews')) || 0;

      if (count <= 0) return;

      var key = group + '-' + count;

      if (countedKeys.indexOf(key) !== -1) return;
      countedKeys.push(key);

      totalReviews += count;

      if (rating > 0) {
        totalRatingValue += rating * count;
      }
    });

    if (totalReviews > 0) {
      var avg = totalRatingValue > 0
        ? (totalRatingValue / totalReviews).toFixed(1)
        : '5.0';

      textEl.textContent = avg + ' from ' + totalReviews + ' reviews';
      wrapper.style.display = 'flex';
    }
  }

  updateCollectionReviewSummary();
  setTimeout(updateCollectionReviewSummary, 500);
  setTimeout(updateCollectionReviewSummary, 1000);
  setTimeout(updateCollectionReviewSummary, 1500);
  setTimeout(updateCollectionReviewSummary, 2500);

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.collection-review-link');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    var target =
      document.querySelector('#collection-review-carousel .jdgm-rev-widg__title') ||
      document.querySelector('#collection-review-carousel h2') ||
      document.querySelector('#collection-review-carousel');

    if (!target) return;

    var offset = window.innerWidth <= 749 ? 330 : 150;

    function scrollToReviews() {
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }

    scrollToReviews();

    setTimeout(scrollToReviews, 400);
  });

});

// gift option on cart page 
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('GiftNoteToggle');
  var content = document.getElementById('GiftNoteContent');
  var textarea = document.getElementById('GiftMessage');
  var count = document.getElementById('GiftMessageCount');

  if (!toggle || !content || !textarea || !count) return;

  function updateCount() {
    count.textContent = textarea.value.length;
  }

  if (textarea.value.trim() !== '') {
    toggle.checked = true;
    content.classList.add('is-open');
  } else {
    toggle.checked = false;
    content.classList.remove('is-open');
  }

  toggle.addEventListener('change', function () {
    if (toggle.checked) {
      content.classList.add('is-open');
    } else {
      content.classList.remove('is-open');
      textarea.value = '';
      updateCount();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          note: ''
        })
      });
    }
  });

  textarea.addEventListener('input', updateCount);
  updateCount();
});
document.addEventListener('DOMContentLoaded', function () {

  // Top review bar
  const reviewBar = document.querySelector('.jdgm-all-reviews-text');

  if (!reviewBar) return;

  reviewBar.style.cursor = 'pointer';

  reviewBar.addEventListener('click', function (event) {
    event.preventDefault();

    // Find Customer Reviews heading directly
    const reviewHeading = document.querySelector(
      '.jdgm-cards-carousel .jdgm-title'
    );

    if (!reviewHeading) return;

    // Header offset
    const headerOffset = window.innerWidth <= 768 ? 180 : 130;

    const headingPosition =
      reviewHeading.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: headingPosition - headerOffset,
      behavior: 'smooth'
    });
  });

});

// dropdown name only pattern in nightclub and selected product images
// document.addEventListener("DOMContentLoaded", function () {
//   function getPatternName(text) {
//     text = (text || "").trim();
//     return text.includes("|") ? text.split("|").pop().trim() : text;
//   }

//   function getBgUrl(el) {
//     if (!el) return "";
//     const bg = el.style.backgroundImage || window.getComputedStyle(el).backgroundImage;
//     const match = bg.match(/url\(["']?(.*?)["']?\)/);
//     return match ? match[1] : "";
//   }

//   function updateFastBundleTitlesOnly() {
//     document.querySelectorAll(".style_productTitle_7256ce7c a").forEach(function (item) {
//       if (!item.dataset.fullTitle) {
//         item.dataset.fullTitle = item.textContent.trim();
//       }

//       const shortTitle = getPatternName(item.dataset.fullTitle);

//       if (item.textContent.trim() !== shortTitle) {
//         item.textContent = shortTitle;
//       }
//     });
//   }

//   function updateSelectedHeaderImages() {
//     document.querySelectorAll(".MainSection_divider_9cf7f971").forEach(function (section) {
//       const headerImage = section.querySelector(".accordionHead_thumbnailContainer_ce9641cc");
//       const selectedTitleEl = section.querySelector(".SelectedVariantsList_title_95ecbce0");

//       if (!headerImage || !selectedTitleEl) return;

//       const selectedPattern = getPatternName(selectedTitleEl.textContent).toLowerCase();
//       let selectedImageUrl = "";

//       section.querySelectorAll(".style_container_7256ce7c").forEach(function (productItem) {
//         const titleEl = productItem.querySelector(".style_productTitle_7256ce7c a");
//         const imageEl = productItem.querySelector(".style_productImage_7256ce7c");

//         if (!titleEl || !imageEl) return;

//         const fullTitle = titleEl.dataset.fullTitle || titleEl.textContent.trim();
//         const productPattern = getPatternName(fullTitle).toLowerCase();

//         if (productPattern === selectedPattern) {
//           selectedImageUrl = getBgUrl(imageEl);
//         }
//       });

//       if (selectedImageUrl) {
//         headerImage.style.setProperty(
//           "background-image",
//           'url("' + selectedImageUrl + '")',
//           "important"
//         );
//       }
//     });
//   }

//   function runFastBundleFixes() {
//     updateFastBundleTitlesOnly();
//     updateSelectedHeaderImages();
//   }

//   // Initial load
//   setTimeout(runFastBundleFixes, 800);
//   setTimeout(runFastBundleFixes, 2000);
//   setTimeout(runFastBundleFixes, 3500);

//   // Run only after user selects/adds item, not continuously
//   document.body.addEventListener("click", function (e) {
//     if (
//       e.target.closest(".variantSelector_container_f0ad7d97") ||
//       e.target.closest(".style_productContainer_7256ce7c") ||
//       e.target.closest(".Accordion_head_dba7dcc1")
//     ) {
//       setTimeout(runFastBundleFixes, 700);
//       setTimeout(runFastBundleFixes, 1500);
//     }
//   });
// });

